export const SEND_VOUCHER_STATE = 'sendVoucher'

export const SEND_VOUCHER_REQUEST = 'SEND_VOUCHER_REQUEST'
export const SEND_VOUCHER_SUCCESS = 'SEND_VOUCHER_SUCCESS'
export const SEND_VOUCHER_FAILURE = 'SEND_VOUCHER_FAILURE'
